var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_DEGRADATIONS_CHOICES, GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_INSTALLATION_CHOICES, } from '@shared/constants/glassBreakageDamageConstants';
import { GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_DEGRADATIONS_ANSWERS, GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_INSTALLATION_ANSWERS, GLASS_BREAKAGE_TRAD_KEYS, } from '@declaration/constants/glassBreakageDamageConstants';
import { GlassBreakageRoomDamagesCause, GlassBreakageRoomDamagesOrigin, } from '@shared/types/api/glassBreakageDamage';
import ThirdPartyModal from '@declaration/components/thirdParty/ThirdPartyModal.vue';
import { INSURER_CONFIG } from '@shared/insurer';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const thirdParty = namespace('thirdParty');
let GlassBreakageRoomDamagesOriginQuestion = class GlassBreakageRoomDamagesOriginQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isThirdPartyModalOpen = false;
    }
    get roomDamagesCause() {
        return this.qualification.roomDamagesCause;
    }
    get selectedValue() {
        return this.qualification.roomDamagesOrigin;
    }
    get panelTitle() {
        switch (this.roomDamagesCause) {
            case GlassBreakageRoomDamagesCause.Degradations:
                return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damages-origin-degradations-panel-title']);
            case GlassBreakageRoomDamagesCause.Installation:
                return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damages-origin-installation-panel-title']);
            default:
                return '';
        }
    }
    get sidebarTitle() {
        let key;
        switch (this.roomDamagesCause) {
            case GlassBreakageRoomDamagesCause.Degradations:
                key = GLASS_BREAKAGE_TRAD_KEYS['room-damages-origin-degradations-question-sidebar_title'];
                break;
            case GlassBreakageRoomDamagesCause.Installation:
                key = GLASS_BREAKAGE_TRAD_KEYS['room-damages-origin-installation-question-sidebar_title'];
                break;
            default:
                return this.panelTitle;
        }
        return key && this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get choices() {
        switch (this.roomDamagesCause) {
            case GlassBreakageRoomDamagesCause.Degradations:
                return GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_DEGRADATIONS_CHOICES;
            case GlassBreakageRoomDamagesCause.Installation:
                return GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_INSTALLATION_CHOICES;
            default:
                return [];
        }
    }
    get thirdPartyPayload() {
        return {
            step: this.step,
            glassBreakageDamageQualification: {
                id: this.qualification.id,
                roomDamagesOrigin: this.selectedValue,
            },
        };
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.claimTypeTrigram);
    }
    get showHelpLink() {
        var _a, _b;
        if (this.hideHelpLink &&
            ((_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.roomDamagesOrigin) === null || _b === void 0 ? void 0 : _b.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    updateClaim(roomDamagesOrigin) {
        if (roomDamagesOrigin === GlassBreakageRoomDamagesOrigin.Professional) {
            if (this.thirdParties.length === 0)
                this.addNewThirdPartyAndEditIt(false);
            else
                this.setThirdPartyInEditionIndex(0);
            this.updateQualification({
                qualificationPayload: { roomDamagesOrigin },
            });
            this.isThirdPartyModalOpen = true;
        }
        else {
            this.updateAndSaveQualification({
                qualificationPayload: { roomDamagesOrigin },
                step: this.step,
            });
        }
    }
    get answer() {
        if (this.selectedValue === null)
            return null;
        switch (this.roomDamagesCause) {
            case GlassBreakageRoomDamagesCause.Degradations:
                return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_DEGRADATIONS_ANSWERS[this.selectedValue]);
            case GlassBreakageRoomDamagesCause.Installation:
                return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGES_ORIGIN_INSTALLATION_ANSWERS[this.selectedValue]);
            default:
                return null;
        }
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "updateQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    thirdParty.Action('addNewThirdPartyAndEditIt')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "addNewThirdPartyAndEditIt", void 0);
__decorate([
    thirdParty.Action('setThirdPartyInEditionIndex')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "setThirdPartyInEditionIndex", void 0);
__decorate([
    thirdParty.State('thirdParties')
], GlassBreakageRoomDamagesOriginQuestion.prototype, "thirdParties", void 0);
GlassBreakageRoomDamagesOriginQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton, ThirdPartyModal },
        props: QuestionProps,
    })
], GlassBreakageRoomDamagesOriginQuestion);
export default GlassBreakageRoomDamagesOriginQuestion;
